var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",class:_vm.type,attrs:{"onclick":_vm.action},on:{"click":_vm.handleClick}},[_c('p',{staticClass:"button-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }